import { useAuthStoreShallow } from "@/features/authentication";
import { cn } from "@lib/cn";
import { useAnalyticsStoreShallow } from "@pages/analytics/store";
import { MainDataSearch } from "../main-data-search/main-data-search";
import { DateFilter } from "./date-filter";
import { FoldersFilter } from "./folders-filter";
import { LocationFilter } from "./location-filter";
import { OwnerFilter } from "./owner-filter";
import { StoriesFilter } from "./stories-filter";
import { VersionFilter } from "./version-filter";

export const Filters = () => {
  const showMobileMenu = useAnalyticsStoreShallow((s) => s.showMobileMenu);
  const isUserOrCreatorLite = useAuthStoreShallow((s) => s.isUserOrCreatorLite);

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-mb-6 -xl:tw-mb-0">
      <div
        className={cn(
          "-xl:tw-fixed -xl:tw-top-[72px] -xl:tw-left-0 -xl:tw-w-full -xl:tw-bg-white -xl:tw-h-[calc(100%-72px)] -xl:tw-opacity-0 -xl:tw-invisible -xl:tw-transition-opacity -xl:tw-duration-200 -xl:tw-z-100",
          {
            "!tw-opacity-100 !tw-visible": showMobileMenu,
          },
        )}
      >
        <div className="tw-flex tw-items-center tw-justify-start tw-gap-2 -xl:tw-p-4 -xl:tw-flex-col">
          <DateFilter />
          <FoldersFilter />
          <StoriesFilter />
          <VersionFilter />
          <LocationFilter />
          {!isUserOrCreatorLite && <OwnerFilter />}
        </div>
      </div>
      <MainDataSearch />
    </div>
  );
};
